import React from "react";
import { useState, useEffect } from "react";
import TravelItineraryTopButtons from "../../components/TravelItineraryTopButtons/TravelItineraryTopButtons";
import CarryMyPet from "../../images/cmp_logo_minidrawer.svg";
import Plane from "../../images/Air.svg";
import plane from "../../images/orderList-plane.svg";
import map from "../../images/World Map.svg";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CircleIcon from "@mui/icons-material/Circle";
import "./TravelItineraryMain.css";
import DesktopNavbar from "../../components/Navbar/Desktop/DesktopNavbar";
import DesktopMiniDrawer from "../../components/MiniDrawer/DesktopMiniDrawer/DesktopMiniDrawer";
import MobileNavbar from "../../components/Navbar/Mobile/MobileNavbar";
import MobileMiniDrawer from "../../components/MiniDrawer/MobileMiniDrawer/MobileMiniDrawer";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";

function TravelItineraryMain() {
  const [isMiniDrawerVisible, setIsMiniDrawerVisible] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [orderSummary, setOrderSummary] = useState([]);
  const location = useLocation();
  const [activeForm, setActiveForm] = useState({
    customerDetails: true,
    relocationDetails: false,
    petDetails: false,
    preview: false,
    documentation: false,
  });

  useEffect(() => {
    window.scrollTo(0, 0);

    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    console.log(Relocation_ID);
    const storedToken = JSON.parse(localStorage.getItem("accessToken"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}customerget/GetCustomerOrderSummary?relocation_id=` +
            Relocation_ID,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOrderSummary(response.data.data[0]);
          console.log("setOrderSummary", response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const toggleMiniDrawer = () => {
    setIsMiniDrawerVisible(!isMiniDrawerVisible);
  };

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#F2F4F6" }}
        className="orderSummary-mobile-hide"
      >
        <div
          style={{ padding: "0px", margin: "0px" }}
          className="container-fluid navbar-mobile-hide"
        >
          <DesktopNavbar />
        </div>
        <div className="row p-0">
          <div className="col-2 p-0">
            <DesktopMiniDrawer />
          </div>
          <div className="col-10 px-3" style={{ marginTop: "90px" }}>
            <TravelItineraryTopButtons />
            <div
              className="container-fluid px-3 py-4"
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                backgroundColor: "white",
                borderRadius: "7px",
              }}
            >
              <div className="">
                <div
                  style={{ height: "45px" }}
                  className="row itinerary-main-list px-4"
                >
                  <div className="col-lg-9 col-md-8 itinerary-main-list-left p-0"></div>
                  <div className="col-lg-3 col-md-4  p-0  d-flex justify-content-end align-items-center">
                    <div
                      style={{
                        border: "2px solid #C0C6CC",
                        padding: "7px",
                        borderRadius: "7px",
                        color: "#6a6a6a",
                      }}
                      className="d-flex justify-content-between align-items-center p-2"
                    >
                      <DownloadIcon />
                      <button
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "white",
                        }}
                        className=""
                      >
                        Download Itinerary
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div
                style={{ border: "2px solid #6a6a6a" }}
                className="itinerary-main-content-div container-fluid p-0 mb-5"
              >
                <div
                  style={{ position: "relative", zIndex: "1" }}
                  className="px-4 row top-button-main d-flex justify-content-between align-items-center"
                >
                  <div className="col-2">
                    <img src={CarryMyPet} className="img-fluid" />
                  </div>
                  <div className="col-9"></div>
                  <div
                    style={{
                      height: "112px",
                      width: "108px",
                      position: "absolute",
                      top: "0px",
                      right: "30px",
                      backgroundColor: "white",
                      boxShadow:
                        "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                    }}
                    className="col-1 text-center p-4"
                  >
                    <img src={Plane} className="img-fluid" />
                  </div>
                </div>
                <div className="container-fluid px-4 mt-5">
                  <div
                    style={{ borderBottom: "2px solid #5B489D" }}
                    className="mt-5"
                  >
                    <div className="order-main-list-left px-0 mt-5">
                      <div className=" w-100 d-flex flex-column  align-items-start travel-itinerary-main-heading order-main-list-left-top">
                        <h4
                          className="mt-2"
                          style={{
                            margin: "0px",
                            color: "#3D3D3D",
                            fontSize: "29px",
                          }}
                        >
                          TRAVEL{" "}
                          <span style={{ color: "#5B489D" }}>ITINERARY</span>
                        </h4>
                        <span
                          style={{
                            color: "#474747",
                            fontSize: "12px",
                            borderBottom: "5px solid #5B489D",
                            fontWeight: "bold",
                          }}
                        >
                          ONE LIVE CAT{" "}
                          <span style={{ fontWeight: "400" }}>
                            {orderSummary.delivery_type_name}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container-fluid px-4">
                  <div style={{ position: "relative" }} className="row">
                    <div
                      style={{ position: "absolute", top: "0px" }}
                      className="col-12 container p-0"
                    >
                      <div className="d-flex justify-content-center align-items-center">
                        <img className="img-fluid" src={map} />
                      </div>
                    </div>
                  </div>
                  <div className="row py-0 px-0">
                    <div className="col-12 mt-3 text-end">
                      <h6
                        style={{
                          color: "#FF0000",
                          fontSize: "12px",
                          margin: "0px",
                        }}
                      >
                        JOB ID :{" "}
                        <span style={{ color: "#474747" }}>
                          {orderSummary.Relocation_ID}
                        </span>
                      </h6>
                    </div>
                  </div>
                  <div className="row py-1 px-0">
                    <div className="itinerary-world-content px-2 d-flex flex-column align-items-center p-2">
                      <div
                        style={{ paddingBottom: "0px" }}
                        className="row w-100 flex justify-content-between align-items-center mt-4 px-4"
                      >
                        <div className="col-3 text-center">
                          <h4
                            style={{
                              margin: "0px",
                              color: "#5B489D",
                              fontWeight: "bold",
                              fontSize: "37px",
                            }}
                          >
                            {orderSummary.origin_city1
                              ? orderSummary.origin_city1
                                  .slice(0, 3)
                                  .toUpperCase()
                              : ""}
                          </h4>
                          <h5 style={{ fontSize: "12px" }}>
                            {orderSummary.origin_city1}
                          </h5>
                          <h6
                            style={{
                              color: "#474747",
                              fontWeight: "bold",
                              fontSize: "17px",
                            }}
                          >
                            10 JULY 2024
                          </h6>
                          <h5 style={{ color: "#6A6A6A", fontSize: "15px" }}>
                            WED | 17:20
                          </h5>
                        </div>
                        <div className="d-flex justify-content-between align-items-center col-6">
                          <CircleIcon
                            style={{
                              fontSize: "20px",
                              marginRight: "12px",
                              color: "#6A6A6A",
                            }}
                          />
                          <div
                            style={{
                              position: "relative",
                              border: "none",
                              borderTop: "2px dotted #474747",
                              width: "100%",
                            }}
                          >
                            <hr className="dotted-hr" />
                            <img
                              src={plane}
                              className="img-fluid"
                              style={{
                                position: "absolute",
                                left: "50%",
                                top: "-13px",
                                width: "38px",
                              }}
                            />
                          </div>
                          <ArrowRightIcon
                            style={{ fontSize: "40px", color: "#6A6A6A" }}
                          />
                        </div>

                        <div className="col-3  text-center">
                          <h4
                            style={{
                              margin: "0px",
                              color: "#5B489D",
                              fontWeight: "bold",
                              fontSize: "37px",
                            }}
                          >
                            {orderSummary.destination_city1
                              ? orderSummary.destination_city1
                                  .slice(0, 3)
                                  .toUpperCase()
                              : ""}
                          </h4>
                          <h5 style={{ fontSize: "12px" }}>
                            {orderSummary.destination_city1}
                          </h5>
                          <h6
                            style={{
                              color: "#474747",
                              fontWeight: "bold",
                              fontSize: "17px",
                            }}
                          >
                            10 JULY 2024
                          </h6>
                          <h5 style={{ color: "#6A6A6A", fontSize: "15px" }}>
                            WED | 17:20
                          </h5>
                        </div>
                      </div>
                      <div className="container">
                        <hr className="px-4 py-0" style={{ width: "100%" }} />
                      </div>
                      <div className="py-2 row w-100 flex justify-content-between align-items-center">
                        <div className="col-3 text-center">
                          <h5
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            AIRLINE
                          </h5>
                          <h4
                            style={{
                              color: "#474747",
                              fontWeight: "bold",
                              fontSize: "17px",
                            }}
                          >
                            {orderSummary.airline_train_name}
                          </h4>
                        </div>
                        <div className="col-6 text-center">
                          <h5
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            FLIGHT
                          </h5>
                          <h4
                            style={{
                              color: "#474747",
                              fontWeight: "bold",
                              fontSize: "17px",
                            }}
                          >
                            {orderSummary.airline_train_number}
                          </h4>
                        </div>

                        <div className="col-3  text-center">
                          <h5
                            style={{
                              color: "#6a6a6a",
                              fontWeight: "bold",
                              fontSize: "12px",
                            }}
                          >
                            DELIVERY TYPE
                          </h5>
                          <h4
                            style={{
                              color: "#474747",
                              fontWeight: "bold",
                              fontSize: "17px",
                            }}
                          >
                            {orderSummary.delivery_type_name}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="container-fluid px-4 itinerary-pet-form"
                  style={{ padding: "28px" }}
                >
                  <div className="px-0 py-2">
                    <h4
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        borderBottom: "1px solid #D9D9D9",
                      }}
                      className="mt-0 px-1 relocation-heading2"
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          padding: "10px 18px 10px 18px",
                          borderBottom: "4px solid #5B489D",
                          padding: "0px",
                          color: "#474747",
                        }}
                        className="text-start"
                      >
                        PET{" "}
                      </span>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          padding: "10px 18px 10px 18px",
                          borderBottom: "4px solid #5B489D",
                          padding: "0px",
                          color: "#5B489D",
                        }}
                        className="text-start"
                      >
                        DETAILS{" "}
                      </span>
                    </h4>
                  </div>
                  <div className="travel-itinerary-details-main-info mt-0 px-1 py-0">
                    <div className=" mt-0 form-row  align-items-start">
                      <div className="col-3">
                        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>
                          Pet Type
                        </h3>
                        <h4
                          style={{
                            border: "none",
                            width: "100%",
                            color: "black",
                            padding: "0px",
                          }}
                        >
                          {orderSummary.PetType}
                        </h4>
                      </div>

                      <div className="col-3">
                        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>
                          Breed
                        </h3>
                        <h4
                          style={{
                            border: "none",
                            width: "100%",
                            color: "black",
                            padding: "0px",
                          }}
                        >
                          {orderSummary.petbreedtype}
                        </h4>
                      </div>

                      <div className="col-3">
                        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>
                          Name of Pet
                        </h3>
                        <h4
                          style={{
                            border: "none",
                            width: "100%",
                            color: "black",
                            padding: "0px",
                          }}
                        >
                          {orderSummary.pet_Name}
                        </h4>
                      </div>

                      <div className="col-3">
                        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>
                          Age
                        </h3>
                        <h4
                          style={{
                            border: "none",
                            width: "100%",
                            color: "black",
                            padding: "0px",
                          }}
                        >
                          {orderSummary.Pet_Age}
                        </h4>
                      </div>
                    </div>

                    <div className="form-row mt-0 row align-items-center">
                      <div className="col-3">
                        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>
                          Cage Size
                        </h3>
                        <h4
                          style={{
                            border: "none",
                            width: "100%",
                            color: "black",
                            padding: "0px",
                          }}
                        >
                          24 Inches
                        </h4>
                      </div>

                      <div className="col-3">
                        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>
                          Cage Status
                        </h3>
                        <h4
                          style={{
                            border: "none",
                            width: "100%",
                            color: "black",
                            padding: "0px",
                          }}
                        >
                          Complementary
                        </h4>
                      </div>

                      <div className="col-3">
                        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>
                          Date of Pet Travel
                        </h3>
                        <h4
                          style={{
                            border: "none",
                            width: "100%",
                            color: "black",
                            padding: "0px",
                          }}
                        >
                          10 Jul 2024 | Wednesday{" "}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-0 m-0">
                  <div className="px-4 py-0">
                    <h4
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        borderBottom: "1px solid #D9D9D9",
                      }}
                      className="mt-0 px-2  mb-4relocation-heading2"
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          padding: "10px 18px 10px 18px",
                          borderBottom: "4px solid #5B489D",
                          padding: "0px",
                          color: "#474747",
                        }}
                        className="text-start"
                      >
                        TRAVEL{" "}
                      </span>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "bold",
                          padding: "10px 18px 10px 18px",
                          borderBottom: "4px solid #5B489D",
                          padding: "0px",
                          color: "#5B489D",
                        }}
                        className="text-start"
                      >
                        DETAILS{" "}
                      </span>
                    </h4>
                  </div>
                  <div className="row px-3 py-4 mb-5">
                    <div className="col-6 px-3">
                      <h4
                        className="heading text-center"
                        style={{ fontSize: "12px" }}
                      >
                        Pick-up Details
                      </h4>
                      <div
                        style={{
                          border: "3px solid rgb(229 225 225)",
                          paddingTop: "10px",
                        }}
                        className="col-lg-12 col-md-12 itinerary-main-list-right"
                      >
                        <div
                          style={{ border: "none" }}
                          className="row itinerary-main-list-right-content"
                        >
                          <div class="container-fluid p-0  text-start">
                            <div class="row p-3">
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Pick-up Contact Details{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                {orderSummary.origin_contact_person} ,
                                {orderSummary.sender_contact_no} ,
                                {orderSummary.sender_alternate_no}
                              </span>
                            </div>
                          </div>
                          <div class="container-fluid p-0  text-start">
                            <div
                              style={{ backgroundColor: "#F6F3FF" }}
                              class="row p-3"
                            >
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Pick-up Address
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                {orderSummary.origin_address}
                              </span>
                            </div>
                          </div>{" "}
                          <div class="container-fluid p-0  text-start">
                            <div class="row p-3">
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Pick-up Time (Tentative)
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                Tentatively pet will be handover by 00:00 -
                                01:00 HRS of 11th July 2024, Thursday
                              </span>
                            </div>
                          </div>{" "}
                          <div class="container-fluid p-0  text-start">
                            <div
                              style={{ backgroundColor: "#F6F3FF" }}
                              class="row p-3"
                            >
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Estimated Departure
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                {orderSummary.departure_time}{" "}
                                {orderSummary.origin_city1} ({" "}
                                {orderSummary.origin_city1
                                  ? orderSummary.origin_city1
                                      .slice(0, 3)
                                      .toUpperCase()
                                  : ""}{" "}
                                )
                              </span>
                            </div>
                          </div>{" "}
                          <div class="container-fluid p-0  text-start">
                            <div class="row p-3">
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Executive Contact (Origin){" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                Mr. Guruprasad ; +91-8147674625
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-6 px-3">
                      <h4
                        className="heading text-center"
                        style={{ fontSize: "12px" }}
                      >
                        Drop Details
                      </h4>
                      <div
                        style={{
                          border: "3px solid rgb(229 225 225)",
                          paddingTop: "10px",
                        }}
                        className="col-lg-12 col-md-12 itinerary-main-list-right"
                      >
                        <div
                          style={{ border: "none" }}
                          className="row itinerary-main-list-right-content"
                        >
                          <div class="container-fluid p-0  text-start">
                            <div class="row p-3">
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Drop Contact Details{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                {orderSummary.destination_contact_person} ,
                                {orderSummary.receiver_contact_no} ,
                                {orderSummary.receiver_alternate_no}
                              </span>
                            </div>
                          </div>
                          <div class="container-fluid p-0  text-start">
                            <div
                              style={{ backgroundColor: "#F6F3FF" }}
                              class="row p-3"
                            >
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Drop Address
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                {orderSummary.destination_address}
                              </span>
                            </div>
                          </div>{" "}
                          <div class="container-fluid p-0  text-start">
                            <div class="row p-3">
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Handover Time (Tentative)
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                Tentatively pet will be handover by 00:00 -
                                01:00 HRS of 11th July 2024, Thursday
                              </span>
                            </div>
                          </div>{" "}
                          <div class="container-fluid p-0  text-start">
                            <div
                              style={{ backgroundColor: "#F6F3FF" }}
                              class="row p-3"
                            >
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Estimated Arrival
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                {orderSummary.arrival_time}{" "}
                                {orderSummary.destination_city1} (
                                {orderSummary.destination_city1
                                  ? orderSummary.destination_city1
                                      .slice(0, 3)
                                      .toUpperCase()
                                  : ""}
                                )
                              </span>
                            </div>
                          </div>{" "}
                          <div class="container-fluid p-0  text-start">
                            <div class="row p-3">
                              <span
                                style={{ fontWeight: "bold", color: "#6a6a6a" }}
                                class="col-5 py-0 px-0"
                              >
                                Executive Contact (Destination){" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-1 p-0"
                              >
                                :{" "}
                              </span>
                              <span
                                style={{ fontWeight: "500", color: "#474747" }}
                                class="col-6 p-0"
                              >
                                {" "}
                                Mr. Guruprasad ; +91-8147674625
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* mobile view  */}
      {/* <div style={{ backgroundColor: "#F2F4F6"}} className="orderSummary-mobile-show">
        <div style={{ padding: "0px", margin: "0px" ,opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s'}} className='container-fluid'>
          <MobileNavbar onToggle={toggleMiniDrawer} active="ordersummary" />
        </div>
        <div className='row p-0'>
          <div className='col-12 p-0 mobile-view-show' style={{ opacity: isMiniDrawerVisible ? 0.5 : 1, transition: 'opacity 0.3s',marginTop:"81px"}}>
            <TravelItineraryTopButtons  />
            <div className='container-fluid px-3 py-4' style={{ boxShadow:
      "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
      backgroundColor: "white",borderRadius:"7px"}}>
        <div className=''>
              <div style={{height:"45px"}} className='row itinerary-main-list px-4'>
<div className='col-lg-9 col-md-8 itinerary-main-list-left p-0'>
</div>
<div className='col-lg-3 col-md-4  p-0  d-flex justify-content-end align-items-center'>
  <div style={{ border: "2px solid #C0C6CC",  padding: "7px", borderRadius: "7px",color:"#6a6a6a" }} className='d-flex justify-content-between align-items-center p-2'>
   <DownloadIcon/>
    <button style={{ border: "none", outline: "none" ,backgroundColor:"white"}} className="">Download Itinerary</button>
  </div>
</div>

  </div></div>
    <hr/>
    <div style={{border:"2px solid #6a6a6a"}} className='itinerary-main-content-div container-fluid p-0 mb-5'>

<div style={{position:"relative",zIndex:"1"}} className='px-4 row top-button-main d-flex justify-content-between align-items-center'>
<div className='col-2'>
<img src={CarryMyPet} className='img-fluid' />
</div>
<div className='col-9'>
</div>
<div  style={{height:"112px",width:"108px",position:"absolute",top:"0px",right:"30px",backgroundColor:"white", boxShadow:
      "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px"}} className='col-1 text-center p-4'>
<img src={Plane} className='img-fluid' />
</div>
</div>
<div className='container-fluid px-4 mt-5'>
<div style={{borderBottom:"2px solid #5B489D"}} className='mt-5'>
<div className='order-main-list-left px-0 mt-5'>
  <div  className=' w-100 d-flex flex-column  align-items-start travel-itinerary-main-heading order-main-list-left-top'>
    <h4 className='mt-2' style={{margin:"0px",color:"#3D3D3D",fontSize:"29px"}}>TRAVEL <span style={{color:"#5B489D"}}>ITINERARY</span></h4>
    <span style={{color:"#474747",fontSize:"12px",borderBottom:"5px solid #5B489D",fontWeight:"bold"}}>ONE LIVE CAT <span style={{fontWeight:"400"}}>(DOOR-TO-DOOR)</span></span>
  </div>
</div>
</div>
</div>

<div   className='container-fluid px-4'>
  <div style={{position:"relative"}} className='row'>
  <div style={{position:"absolute",top:"0px"}} className='col-12 container p-0'>
 <div  className="d-flex justify-content-center align-items-center">
  <img className='img-fluid' src={map}/>
</div>
 </div>
  </div>
<div className='row py-0 px-0'>
<div className='col-12 mt-3 text-end'>
<h6 style={{color:"#FF0000",fontSize:"12px",margin:"0px"}}>JOB ID : <span style={{color:"#474747"}}>53349</span></h6>
</div>
</div>
<div className='row py-1 px-0'>
 <div className='itinerary-world-content px-2 d-flex flex-column align-items-center p-2'>
  <div style={{paddingBottom:"0px"}} className='row w-100 flex justify-content-between align-items-center mt-4 px-4'>
<div className='col-3 text-center' >
<h4  style={{margin:"0px",color:"#5B489D",fontWeight:"bold",fontSize:"37px"}}>DEL</h4>
<h5 style={{fontSize:"12px"}}>New Delhi</h5>
<h6 style={{color:"#474747",fontWeight:"bold",fontSize:"17px"}}>10 JULY 2024</h6>
<h5 style={{color:"#6A6A6A",fontSize:"15px"}}>WED | 17:20</h5>
</div>
<div className='d-flex justify-content-between align-items-center col-6'>
  <CircleIcon style={{fontSize:"20px",marginRight:"12px",color:"#6A6A6A"}}/>
  <div  style={{position:"relative", border: "none", borderTop: "2px dotted #474747",width:"100%" }} >
  <hr className="dotted-hr" />
  <img src={plane} className='img-fluid' style={{position:"absolute",left:"50%",top:"-13px",width:"38px"}}/>
  </div>
  <ArrowRightIcon style={{fontSize:"40px",color:"#6A6A6A"}} />
</div>

<div className='col-3  text-center' >
<h4 style={{margin:"0px",color:"#5B489D",fontWeight:"bold",fontSize:"37px"}}>BLR</h4>
<h5 style={{fontSize:"12px"}}>Bengaluru</h5>
<h6 style={{color:"#474747",fontWeight:"bold",fontSize:"17px"}}>10 JULY 2024</h6>
<h5 style={{color:"#6A6A6A",fontSize:"15px"}}>WED | 17:20</h5>
</div>
 </div>
 <div className='container'>
 <hr className='px-4 py-0' style={{width:"100%"}}/>
 
 </div>
 <div className='py-2 row w-100 flex justify-content-between align-items-center'>
<div className='col-3 text-center' >
<h5 style={{color:"#6a6a6a",fontWeight:"bold",fontSize:"12px"}}>AIRLINE</h5>
<h4 style={{color:"#474747",fontWeight:"bold",fontSize:"17px"}}>AIR INDIA</h4>
</div>
<div className='col-6 text-center'>
<h5 style={{color:"#6a6a6a",fontWeight:"bold",fontSize:"12px"}}>FLIGHT</h5>
<h4 style={{color:"#474747",fontWeight:"bold",fontSize:"17px"}}>AI 807</h4>
</div>

<div className='col-3  text-center' >
<h5 style={{color:"#6a6a6a",fontWeight:"bold",fontSize:"12px"}}>DELIVERY TYPE</h5>
<h4 style={{color:"#474747",fontWeight:"bold",fontSize:"17px"}}>DOOR-TO-DOOR</h4>
</div>
 </div>
 </div>
 </div>
</div>
<div className="container-fluid px-4 itinerary-pet-form" style={{ padding: "28px" }}>
<div className='px-0 py-2'>
      <h4
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              borderBottom:"1px solid #D9D9D9"
            }}
            className="mt-0 px-1 relocation-heading2"
          >
            <span style={{
              fontSize: "13px",
              fontWeight: "bold",
              padding: "10px 18px 10px 18px",
              borderBottom:"4px solid #5B489D",
              padding:"0px",
              color:"#474747"
            }} className="text-start" >
            PET         </span>
            <span style={{
              fontSize: "13px",
              fontWeight: "bold",
              padding: "10px 18px 10px 18px",
              borderBottom:"4px solid #5B489D",
              padding:"0px",
              color:"#5B489D"
            }} className="text-start" >
           DETAILS          </span>
           
          </h4>    
        </div>
  <div className="travel-itinerary-details-main-info mt-0 px-1 py-0">
    <div className=" mt-0 form-row  align-items-start">
      <div className="col-3">
        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>Pet Type</h3>
        <h4 style={{ border: "none", width: "100%", color: "black", padding: "0px" }}>
        Indie Ginger Cat
                </h4>
      </div>
      
      <div className="col-3">
        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>Breed</h3>
        <h4 style={{ border: "none", width: "100%", color: "black", padding: "0px" }}>
        Indie Ginger Cat
        </h4>
      </div>
      
      <div className="col-3">
        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>Name of Pet</h3>
        <h4 style={{ border: "none", width: "100%", color: "black", padding: "0px" }}>
        LOLA
        </h4>
      </div>
      
      <div className="col-3">
        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>Age</h3>
        <h4 style={{ border: "none", width: "100%", color: "black", padding: "0px" }}>
        1 year and 10 months
        </h4>
      </div>
    </div>

    <div className="form-row mt-0 row align-items-center">
      <div className="col-3">
        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>Cage Size</h3>
        <h4 style={{ border: "none", width: "100%", color: "black", padding: "0px" }}>
    24 Inches
        </h4>
      </div>
      
      <div className="col-3">
        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>Cage Status</h3>
        <h4 style={{ border: "none", width: "100%", color: "black", padding: "0px" }}>
        Complementary
        </h4>
      </div>
      
      <div className="col-3">
        <h3 style={{ color: "#6a6a6a", marginTop: "29px" }}>Date of Pet Travel</h3>
        <h4 style={{ border: "none", width: "100%", color: "black", padding: "0px" }}>
        10 Jul 2024 | Wednesday        </h4>
      </div>
    </div>
  </div>
</div>

      <div className='p-0 m-0'>
        <div className='px-4 py-0'>
      <h4
            style={{
              fontSize: "13px",
              fontWeight: "bold",
              borderBottom:"1px solid #D9D9D9"
            }}
            className="mt-0 px-2  mb-4relocation-heading2"
          >
            <span style={{
              fontSize: "13px",
              fontWeight: "bold",
              padding: "10px 18px 10px 18px",
              borderBottom:"4px solid #5B489D",
              padding:"0px",
              color:"#474747"
            }} className="text-start" >
            TRAVEL           </span>
            <span style={{
              fontSize: "13px",
              fontWeight: "bold",
              padding: "10px 18px 10px 18px",
              borderBottom:"4px solid #5B489D",
              padding:"0px",
              color:"#5B489D"
            }} className="text-start" >
           DETAILS          </span>
           
          </h4>    
        </div>
            <div className="row px-3 py-4 mb-5">
  <div className="col-6 px-3">
    <h4 className='heading text-center' style={{fontSize:"12px"}}>Pick-up Details</h4>
    <div style={{ border: "3px solid rgb(229 225 225)", paddingTop: "10px" }} className='col-lg-12 col-md-12 itinerary-main-list-right'>
      <div style={{ border: "none" }} className='row itinerary-main-list-right-content'>
      <div class="container-fluid p-0  text-start">
  <div  class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Pick-up Contact 
       Details </span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> Mr. Mukul Sharma, +91 898 808 7890, +91 897 789 7890</span>
     </div>
</div>
<div class="container-fluid p-0  text-start">
  <div style={{ backgroundColor: "#F6F3FF" }} class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Pick-up  Address</span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> 208, DLT Residency Apartment, Crossroad, Bengalurur -560066</span>
     </div>
</div> <div class="container-fluid p-0  text-start">
  <div  class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Pick-up Time 
       
       (Tentative)</span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> Tentatively pet will be handover by
          00:00 - 01:00 HRS of 11th July 2024, Thursday</span>
     </div>
</div> <div class="container-fluid p-0  text-start">
  <div style={{ backgroundColor: "#F6F3FF" }} class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Estimated 
       Departure</span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">:</span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> 20:10 HRS Bengaluru(BLR)</span>
     </div>
</div> <div class="container-fluid p-0  text-start">
  <div class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Executive Contact
       (Origin) </span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0">Mr. Guruprasad ; +91-8147674625</span>
     </div>
</div>
      </div>
    </div>
  </div>

  <div className="col-6 px-3">
    <h4 className='heading text-center' style={{fontSize:"12px"}}>Drop Details</h4>
    <div style={{ border: "3px solid rgb(229 225 225)", paddingTop: "10px" }} className='col-lg-12 col-md-12 itinerary-main-list-right'>
      <div style={{ border: "none" }} className='row itinerary-main-list-right-content'>
      <div class="container-fluid p-0  text-start">
  <div  class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Drop Contact 
       Details </span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> Mr. Mukul Sharma, +91 898 808 7890, +91 897 789 7890</span>
     </div>
</div>
<div class="container-fluid p-0  text-start">
  <div style={{ backgroundColor: "#F6F3FF" }} class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Drop Address</span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> 208, DLT Residency Apartment, Crossroad, Bengalurur -560066</span>
     </div>
</div> <div class="container-fluid p-0  text-start">
  <div  class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Handover Time 
       (Tentative)</span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> Tentatively pet will be handover by
          00:00 - 01:00 HRS of 11th July 2024, Thursday</span>
     </div>
</div> <div class="container-fluid p-0  text-start">
  <div style={{ backgroundColor: "#F6F3FF" }} class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Estimated 
       Arrival</span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">:</span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> 20:10 HRS Bengaluru(BLR)</span>
     </div>
</div> <div class="container-fluid p-0  text-start">
  <div class="row p-3">
       <span style={{fontWeight:"bold", color:"#6a6a6a"}}  class="col-5 py-0 px-0">Executive Contact
       (Destination) </span>
       <span style={{fontWeight:"500", color:"#474747"}}  class="col-1 p-0">: </span>
          <span style={{fontWeight:"500", color:"#474747"}}  class="col-6 p-0"> Mr. Guruprasad ; +91-8147674625</span>
     </div>
</div>
      </div>
    </div>
  </div>
</div>

    </div>
    </div>
        </div>
          </div>
          {isMiniDrawerVisible && (
            <div className='col-12'>
              <MobileMiniDrawer onClose={toggleMiniDrawer} />
            </div>
          )}
        </div>
      </div> */}
    </>
  );
}

export default TravelItineraryMain;
